import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import { L10nConfig, L10nTranslationLoader, L10nProvider } from 'angular-l10n';
import { Observable, from } from 'rxjs';

export const l10nConfig: L10nConfig = {
  format: 'language',

  providers: [
    {
      name: 'locale',
      asset: './assets/resources/locale',
      options: { version: '11.0.0' },
    },
  ],
  fallback: false,
  cache: true,
  keySeparator: '.',
  defaultLocale: { language: 'en' },
  schema: [
    { locale: { language: 'en' }, dir: 'ltr', text: 'United States' },
    { locale: { language: 'de' }, dir: 'ltr', text: 'Germany' },
  ],
};

@Injectable()
export class HttpTranslationLoader implements L10nTranslationLoader {
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(@Optional() private http: HttpClient) {}

  public get(
    language: string,
    provider: L10nProvider
  ): Observable<{ [key: string]: any }> {
    const url = `${provider.asset}-${language}.json`;
    const options = {
      headers: this.headers,
      params: new HttpParams().set('v', provider.options.version),
    };
    return this.http.get(url, options);
  }
}
